// extracted by mini-css-extract-plugin
module.exports = {"root":"photos-module--root--2pTyE"};